module.exports = {"2006-01-01T00:00:00Z":14.8046,"2007-01-01T00:00:00Z":14.1764,"2008-01-01T00:00:00Z":14.0226,"2009-01-01T00:00:00Z":14.2843,"2010-01-01T00:00:00Z":13.6164,"2011-01-01T00:00:00Z":14.4093,"2012-01-01T00:00:00Z":14.1882,"2013-01-01T00:00:00Z":14.5375,"2014-01-01T00:00:00Z":15.2654,"2015-01-01T00:00:00Z":14.8082,"2016-01-01T00:00:00Z":15.0538,"2017-01-01T00:00:00Z":14.1679}


//////////////////
// WEBPACK FOOTER
// ./src/components/core/predictivos/aemet.json
// module id = 1089
// module chunks = 1